module.exports = __webpack_public_path__ + "static/umar-3f75b74ea08f410c2f47710557a40972.png";